/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiNameCardinalitiesByAccountResponse
 */
export interface InternalApiNameCardinalitiesByAccountResponse {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof InternalApiNameCardinalitiesByAccountResponse
     */
    nameCardinalitiesByAccount: { [key: string]: number; };
}

/**
 * Check if a given object implements the InternalApiNameCardinalitiesByAccountResponse interface.
 */
export function instanceOfInternalApiNameCardinalitiesByAccountResponse(value: object): value is InternalApiNameCardinalitiesByAccountResponse {
    if (!('nameCardinalitiesByAccount' in value) || value['nameCardinalitiesByAccount'] === undefined) return false;
    return true;
}

export function InternalApiNameCardinalitiesByAccountResponseFromJSON(json: any): InternalApiNameCardinalitiesByAccountResponse {
    return InternalApiNameCardinalitiesByAccountResponseFromJSONTyped(json, false);
}

export function InternalApiNameCardinalitiesByAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiNameCardinalitiesByAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nameCardinalitiesByAccount': json['nameCardinalitiesByAccount'],
    };
}

export function InternalApiNameCardinalitiesByAccountResponseToJSON(json: any): InternalApiNameCardinalitiesByAccountResponse {
    return InternalApiNameCardinalitiesByAccountResponseToJSONTyped(json, false);
}

export function InternalApiNameCardinalitiesByAccountResponseToJSONTyped(value?: InternalApiNameCardinalitiesByAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nameCardinalitiesByAccount': value['nameCardinalitiesByAccount'],
    };
}

